import React, { createContext, useContext } from 'react';

import 'firebase/analytics';

import FirebaseProvider from './FirebaseProvider';
import { IAnalyticsData } from './types';

interface IAnalyticsCtx {
	app: firebase.app.App;
	fire: (eventName: string, data: IAnalyticsData) => void;
	isUserPropsSent: boolean;
}

const AnalyticContext = createContext<IAnalyticsCtx>({} as IAnalyticsCtx);

const { Provider } = AnalyticContext;

interface IAnalyticsOptions {
	appName: string;
	firebaseConfig: unknown;
}

const noopFire = (eventName: string, data: IAnalyticsData) => console.warn('Analytics[noop]:', eventName, data); // eslint-disable-line no-console

export const AnalyticsProvider: React.FC<{ value: IAnalyticsOptions }> = ({ children, value }) => {
	const { appName, firebaseConfig } = value;
	try {
		const app = FirebaseProvider(firebaseConfig, appName);
		const analytics = app.analytics();
		const fire = (eventName: string, data: IAnalyticsData) => {
			analytics.logEvent(eventName, data);
		};
		return <Provider value={{ app, fire, isUserPropsSent: false }}>{children}</Provider>;
	} catch (e) {
		console.warn('Unable to initialise analytics'); // eslint-disable-line no-console
	}
	return <Provider value={{ fire: noopFire, isUserPropsSent: false } as IAnalyticsCtx}>{children}</Provider>;
};

export default AnalyticContext;

export const useAnalyticsCtx = (): IAnalyticsCtx => useContext(AnalyticContext);
